<ul *ngIf="detail && detail.type !== 'encadrement' && detail.type !== 'indispo' && detail.type !== 'ignore'">
  <li>
    Session: <a class="primary-color" target="_blank" [routerLink]="[linkSession]">{{ detail.session }}</a>
  </li>
  <li>Produit: {{ detail.produit }}</li>
  <li>Client(s): {{ detail.client }}</li>

  <ng-container *ngFor="let element of detail.intervention; index as i">
    <h6>Intervention {{ i + 1 }}</h6>
    <li>Du: {{ element.dateSession | date: 'dd/MM/yyyy' }} - {{ element.heureDebut }}</li>
    <li>Au: {{ element.dateSession | date: 'dd/MM/yyyy' }} - {{ element.heureFin }}</li>
    <li *ngIf="element.soustraitant">Sous-traitant(s): {{ element.soustraitant }}</li>
    <li *ngIf="element.formateur">Formateur(s): {{ element.formateur }}</li>
    <li *ngIf="element.site">
      Site(s): {{ element.site }} <br/>
      {{ element.site_adresse }} <br/>
      {{ element.site_cp }} {{ element.site_ville }} <br/>
    </li>
    <li *ngIf="element.contact">
      Contact: {{ element.contact }} <br/>
      {{ element.contact_tel }}
    </li>
  </ng-container>
</ul>
